var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('h1',{staticClass:"mt-5 pt-1"},[_vm._v("Welcome")]),_c('router-link',{staticClass:"btn btn-lg btn-primary",attrs:{"tag":"a","exact":"","to":"/login"}},[_vm._v(" Sign in")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }